import styled, { createGlobalStyle } from "styled-components";

export const SidebarBackdrop = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: var(--sidenav-width, 0px);
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1039;
  opacity: ${(props) => (props.open ? 1 : 0)};
  visibility: ${(props) => (props.open ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.open ? "auto" : "none")};
  transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;
`;

export const SidebarPanel = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: var(--sidenav-width, 0px);
  width: 340px;
  max-width: 90vw;
  background-color: #fff;
  z-index: 1041;
  transform: translateX(
    ${(props) => (props.open ? "0" : "calc(-100% - var(--sidenav-width, 0px))")}
  );
  transition: transform 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
`;

export const RightSidebarPanel = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 70%;
  max-width: 90vw;
  background-color: #fff;
  z-index: 1050;
  transform: translateX(${(props) => (props.open ? "0" : "100%")});
  transition: transform 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.1);
`;

export const SidebarToggle = styled.button<{ open: boolean }>`
  position: fixed;
  top: 100px;
  left: var(--sidenav-width, 0px);
  width: 22px;
  height: 56px;
  background-color: ${(props) => (props.open ? "#fff" : "#2c5fd9")};
  color: ${(props) => (props.open ? "#2c5fd9" : "#fff")};
  border: 1px solid ${(props) => (props.open ? "#e9ecef" : "#2c5fd9")};
  border-left: 0;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-shadow: ${(props) =>
    props.open ? "none" : "2px 0 6px rgba(44, 95, 217, 0.2)"};
  transform: translateX(${(props) => (props.open ? "340px" : "0")});
  transition: transform 0.25s ease-in-out, background-color 0.15s ease-in-out,
    color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  z-index: 1040;

  &:hover {
    background-color: ${(props) => (props.open ? "#f6f9fc" : "#1a4ab9")};
    color: ${(props) => (props.open ? "#2c5fd9" : "#fff")};
  }

  /* O icone e o funil, nao uma seta: girar nao comunicaria nada. */
  i {
    font-size: 0.75rem;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const SidebarBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
`;

export const DivCard = styled.div<{ cardColor?: string }>`
  white-space: initial;
  background-color: white;
  padding: 8px;
  margin: auto auto 10px;
  border-radius: 8px;
  width: 270px;
  max-width: 270px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: 100ms;
  border-left: ${props => props.cardColor ? `5px solid ${props.cardColor}` : 'none'};
  :hover {
    background-color: #ffffff;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
`;

export const KanbanGlobalStyle = createGlobalStyle`
  /*
   * IMPORTANTE: a lane (Section do react-trello) já vem com
   * display: inline-flex; flex-direction: column por padrão.
   * NÃO sobrescrever para "display: flex" — block-level flex quebra o layout
   * horizontal e empilha as lanes verticalmente. Aqui só garantimos min-height: 0
   * para os filhos poderem encolher dentro do flex container.
   */
  .kanban-board-wrapper .react-trello-lane {
    min-height: 0;
  }

  /*
   * ScrollableLane do react-trello (div interno que envolve cards + AddCardLink).
   * Por padrão tem overflow-y: auto, então o AddCardLink scrolla junto.
   * Targetamos via :has(.smooth-dnd-container) — é o único div da lane com esse filho.
   * Transformamos em flex container e tiramos o overflow daqui.
   */
  .kanban-board-wrapper .react-trello-lane > div:has(> .smooth-dnd-container) {
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    flex: 1 1 auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin-top: 0 !important;
  }

  /* Container dos cards passa a ser o único elemento que scrolla */
  .kanban-board-wrapper .react-trello-lane .smooth-dnd-container.vertical {
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 80px;
    border-radius: 6px;
    transition: background-color 120ms ease, box-shadow 120ms ease;
  }

  /* Quando arrasta, todas as lanes ficam levemente destacadas */
  .kanban-board-wrapper.is-dragging .smooth-dnd-container.vertical {
    background-color: rgba(94, 114, 228, 0.04);
    outline: 2px dashed rgba(94, 114, 228, 0.25);
    outline-offset: -4px;
  }

  /* Lane que está recebendo o drop — destaque mais forte */
  .kanban-board-wrapper .smooth-dnd-container.vertical.smooth-dnd-drop-preview-default-class,
  .kanban-board-wrapper .smooth-dnd-container.vertical:has(.smooth-dnd-drop-preview-constant-class) {
    background-color: rgba(46, 204, 113, 0.08);
    outline: 2px dashed #2dce89;
    outline-offset: -4px;
  }

`;
